<template>
	 <mt-popup v-model="popupFarmVisible" style="width:100%"  position="bottom">
		<div class="searchBox"> 
			<div @click="closedHandle" class="pickerCancel">取消</div>
			<input class="picker-input" v-if="searchKeyword" v-model="keyword" placeholder="请输入关键字查询" @blur="searchHandle" />
			<div @click="confirmHandle" class="pickerConfirm">确认</div>
		</div>
        <mt-picker  :slots="listData" value-key="name" @change="bindChange" :value="setValues" ></mt-picker>
    </mt-popup> 
</template>
<script>  
 
function debounce(fn, interval = 500, immediate = false) {
    //fn为要执行的函数
    //interval为等待的时间
    //immediate判断是否立即执行
    var timeout; //定时器
   
    return function() {
      //返回一个闭包
      var context = this,
        args = arguments; //先把变量缓存
      var later = function() {
        //把稍后要执行的代码封装起来
        timeout = null; //成功调用后清除定时器
        if (!immediate) fn.apply(context, args); //不立即执行时才可以调用
      };
   
      var callNow = immediate && !timeout; //判断是否立即调用，并且如果定时器存在，则不立即调用
      clearTimeout(timeout); //不管什么情况，先清除定时器，这是最稳妥的
      timeout = setTimeout(later, interval); //延迟执行
      if (callNow) fn.apply(context, args); //如果是第一次触发，并且immediate为true，则立即执行
    };
  } 
	export default {

		props: { 
			dataSource: {
				type: Array,
				default () {
					return []
				}
			},
			pickerValues: { //picker默认展示的值
				type: Array,
				default () {
					return [0]
				}
			},
			searchKeyword: { 
				type: Boolean,
				default () {
					return false
				}
			},
		},
		data() {
			return {
				popupFarmVisible:false,
				form: { //要传过去的值
					id: '',
					name: ''
				},
				setValues:[0],
				keyword:'',
				listData:[],
				isMoving:false,
				debouncedSearch: debounce(this.debounceFun, 500)//防抖处理
			};
		},
		watch: {
			dataSource: {
				handler(newValue, oldValue) {
					this.listData = [{values: newValue}] 
				},
				deep: true,
				immediate: true,
			}
		},
		mounted() {  
		},
		
		methods: { 
			show(){ 
				this.listData = [{values: this.dataSource}] 
				this.popupFarmVisible = true
			},
			init() {
				this.$nextTick(() => {//组件渲染完成后在更新数据
					this.setValues = this.pickerValues
				})
			},
			searchHandle(val) {
			this.debouncedSearch(this.keyword);
			},
			debounceFun(data) {
				this.form = {id:''}
				this.isMoving = false
				this.setValues = [0]
				this.$emit('searchHandle', data);
			},
			confirmHandle(val){
				if (this.isMoving) {
					console.log('运动中，不能点击哦')
					return;
				}  
				if (this.form.id == '' && this.listData.length > 0) {
					this.form = {
						id: this.listData[0].values[0].id,
						name: this.listData[0].values[0].name,
						nameTwo:this.listData[0].values[0].nameTwo || '',
					}
				} 
				if(this.dataSource.length == 0){
					this.$emit('recload', '');
				    this.popupFarmVisible = false
					return
				}
				this.$emit('recload', this.form);
				this.setValues =[0]
				this.popupFarmVisible = false
			},
			bindChange(picker, values) { 
				if(values&&values.length>0&&values[0]){ 
					this.form.id = values[0].id;
					this.form.name = values[0].name
					this.form.nameTwo = values[0].nameTwo
				}
				if (values[0] > values[1]) {
					picker.setSlotValue(1, values[0]);
				}
			},
			closedHandle(){ 
				this.popupFarmVisible = false
				this.setValues =[0]
				this.$emit('closeHandle', false);
			},
		}
	};
</script>
<style scoped lang="scss"> 
	.searchBox{
		padding: 15px;
		text-align: center;
		position: relative;
	}
	.pickerCancel {
		font-size: 15px;
		color: #606266;
		display: inline-block;
		box-sizing: border-box;
		text-align: center;
		text-decoration: none;
		padding: 8px;
		position: absolute;
		left:10px;
    	top: 0px;
	}
	.picker-input{
		display:inline-block;
		border: 1px solid #ddd;
		border-radius: 5px; 
		width: 200px;
		margin-top: 8px;
		text-align: center;
		height: 30px;
		line-height: 30px;
		
	}
	.pickerConfirm {
		font-size: 15px;
		color: #2979ff;
		display: inline-block;
		box-sizing: border-box;
		text-align: center;
		text-decoration: none;
		padding: 8px;
		position: absolute;
		right:10px;
    	top: 0px;
	} 
</style>